import { useEffect, useRef, useState } from 'react';
import { useUnit } from 'effector-react';
import { t } from 'i18next';
import { Badge, ClickAwayListener, IconButton, Tooltip } from '@mui/material';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import { ThemeAdapter } from '@shared/theme/adapter';
import {
  $getBadgeColorAndNumber,
  $notReadImports,
  $openImportsPopperCounter,
  $processingImports,
  ImportTemporalGate,
} from '../model';
import { Toast } from '../model/toast/ui';
import { Loader } from './components/loader';
import { ImportPopper } from './components/popper';
import * as Styled from './styled';

export const ImportTemporal = () => (
  <ThemeAdapter>
    <ImportTemporalBody />
  </ThemeAdapter>
);

export const ImportTemporalBody = () => {
  const [importPopperOpened, setImportPopperOpened] = useState(false);
  const iconButtonRef = useRef<HTMLButtonElement | null>(null);
  const [
    openImportsPopperCounter,
    getBadgeColorAndNumber,
    processingImports,
    notReadImports,
  ] = useUnit([
    $openImportsPopperCounter,
    $getBadgeColorAndNumber,
    $processingImports,
    $notReadImports,
  ]);

  const toggleImportPopperOpened = () => {
    setImportPopperOpened((prev) => !prev);
  };

  useEffect(() => {
    if (!openImportsPopperCounter) return;

    setImportPopperOpened(true);
  }, [openImportsPopperCounter]);

  return (
    <>
      <ImportTemporalGate />

      {!!notReadImports.length && (
        <ClickAwayListener onClickAway={() => setImportPopperOpened(false)}>
          <div>
            <Loader />

            <Toast />

            <Tooltip title={importPopperOpened ? undefined : t('Import')}>
              <IconButton onClick={toggleImportPopperOpened} ref={iconButtonRef}>
                <Badge
                  badgeContent={getBadgeColorAndNumber.number}
                  color={getBadgeColorAndNumber.color}
                >
                  <VerticalAlignBottomIcon />
                </Badge>
              </IconButton>
            </Tooltip>

            {!!processingImports.length && <Styled.LinearProgress />}

            <ImportPopper
              anchorEl={importPopperOpened ? iconButtonRef.current : null}
              setImportPopperOpened={setImportPopperOpened}
            />
          </div>
        </ClickAwayListener>
      )}
    </>
  );
};
